import React, { Fragment, useContext, useEffect, useState } from "react";
import { faCoins, faMoneyCheckDollar, faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FormField, Radio } from "semantic-ui-react";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";

const PaymentTypesButtons = (props) => {
    const { t } = useTranslation();
    const { blockForm, paymentMethod, setPaymentMethod, setFormChanged, showAlerts, showAllTypes } = props;
    const [paymentTypes, setPaymentTypes] = useState(null);
    const { checkServerData } = useContext(BasicContext);

    const getActivePaymentTypes = async () => {
        const res = await postMethod("/get-active-payment-types", { showAllTypes: showAllTypes });
        if (checkServerData(res)) {
            //console.log(res.data.list);
            res.data.list.forEach((e) => {
                e.icon = e.payment_type_code === "CASH" ? faCoins : e.payment_type_code === "MONEY_TRANSFER" ? faMoneyCheckDollar : null;
            });
            setPaymentTypes(res.data.list);
        }
    };

    useEffect(() => {
        getActivePaymentTypes();
        // eslint-disable-next-line
    }, []);

    //console.log(showAlerts, paymentMethod);

    return (
        <Fragment>
            {!paymentTypes ? (
                <p className="fs-6">
                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                </p>
            ) : (
                <Form.Group id={`paymentType`}>
                    <Form.Label className="w-100">
                        {t(`payments.paymentType`)} <span className="req">*</span>
                    </Form.Label>
                    {paymentTypes.map((e, i) => (
                        <FormField key={i}>
                            <Radio
                                disabled={blockForm}
                                label={
                                    <label>
                                        <FontAwesomeIcon icon={faCoins} className="me-2" />
                                        {t(`payments.paymentTypes.${e.payment_type_code}`)}
                                    </label>
                                }
                                name="radioGroup"
                                value={e.payment_type_code}
                                checked={paymentMethod === e.payment_type_code}
                                onChange={() => {
                                    setPaymentMethod(e.payment_type_code);
                                    setFormChanged(true);
                                }}
                                className="bg-white"
                            />
                        </FormField>
                    ))}
                    {showAlerts ? (
                        paymentMethod === "CASH" ? (
                            <Alert variant="warning" className="alert-small">
                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                {t("warning.paymentsCashWarning")}
                            </Alert>
                        ) : paymentMethod === "MONEY_TRANSFER" ? (
                            <Alert variant="warning" className="alert-small">
                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                {t("warning.paymentsMoneyTransferWarning")}
                            </Alert>
                        ) : null
                    ) : null}
                </Form.Group>
            )}
        </Fragment>
    );
};

export default PaymentTypesButtons;
